/**
 * The small rounded status indicator at the top of a Checker/Convoy trip
 * card: a dot (solid, or pulsing while healthy/on-schedule) plus a label.
 * Mirrors the Android app's PulsingDot + status text pairing.
 *
 * @param {string} label - e.g. "Active", "Scheduled", "Overdue"
 * @param {string} color - CSS color for the dot and (unless `filled`) the text
 * @param {boolean} [filled] - Fills the pill with a soft tint of `color`,
 *   instead of a transparent background with colored text/dot only.
 * @param {boolean} [pulsing] - Animates the dot; used only for the plain
 *   "on schedule" state, never for an overdue/danger/pending one.
 */
export default function CheckerStatusPill({ label, color, filled = false, pulsing = false }) {
    return (
        <span
            className="checker-pill"
            style={
                filled
                    ? { backgroundColor: `${color}1f`, color }
                    : { color }
            }
        >
            <span
                className={`checker-pill-dot${pulsing ? " checker-pill-dot-pulsing" : ""}`}
                style={{ backgroundColor: color }}
                aria-hidden="true"
            />
            {label}
        </span>
    )
}
